module.exports = __webpack_public_path__ + "img/zwfp.b5c90334.jpg";